module.exports = __webpack_public_path__ + "static/history-4c86f6c58edd24910e9fbe42dd28cbec.png";